import { DEFAULT_ANIMATE_SETTINGS } from '../constants'
import { threeDStudioStore } from '../index'

/**
 * Resets all animate settings to their default values.
 */
export const clearSettings = () => {
  threeDStudioStore.setState({
    animateSettings: { ...DEFAULT_ANIMATE_SETTINGS },
  })
}
